import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { StateRegistrationModal } from '../StateRegistrationModal';
import { StateRegistrationService } from '../../services/StateRegistrationService';
import { useClientData } from '../../hooks/useClientData';

export const StateRegistrationTracker: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { clients } = useClientData();

  const handleNewRegistration = () => {
    console.log('Opening modal');
    setIsModalOpen(true);
  };

  return (
    <Box>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3
      }}>
        <Typography variant="h5" sx={{ color: 'text.primary' }}>
          State Registration Tracker
        </Typography>
        <Button
          variant="contained"
          onClick={handleNewRegistration}
          sx={{
            bgcolor: '#1976d2',
            '&:hover': {
              bgcolor: '#1565c0'
            },
            textTransform: 'none',
            borderRadius: '4px',
            px: 2
          }}
        >
          + NEW REGISTRATION
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <TableContainer component={Paper} sx={{ bgcolor: 'background.paper' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Organization</TableCell>
              <TableCell>State</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Expiration Date</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Table content */}
          </TableBody>
        </Table>
      </TableContainer>

      <StateRegistrationModal
        open={isModalOpen}
        onClose={() => {
          console.log('Closing modal');
          setIsModalOpen(false);
        }}
        onSubmit={async (data) => {
          try {
            const stateRegistrationService = new StateRegistrationService();
            await stateRegistrationService.initializeRegistration(
              data.fundId, 
              data.state
            );
            setIsModalOpen(false);
          } catch (error) {
            console.error('Failed to initialize registration:', error);
            setError('Failed to create registration. Please try again.');
          }
        }}
        clients={clients}
      />
    </Box>
  );
};